<div class="container">
    <ng-container *ngIf="isReadMode; else writeMode">
        <span *ngIf="isChecked">{{ displayText }}</span>
    </ng-container>
    <ng-template #writeMode>
        <div class="write-mode-container">
            <mat-checkbox 
            color="primary" 
            class="example-margin" 
            [checked]="isChecked" 
            [disabled]="effectiveDisabled"
            (change)="onInternalChange($event.checked)">{{ displayText }}</mat-checkbox>
        </div>
    </ng-template>
</div>